/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialKey } from './ReferentialKey';
import {
    ReferentialKeyFromJSON,
    ReferentialKeyFromJSONTyped,
    ReferentialKeyToJSON,
    ReferentialKeyToJSONTyped,
} from './ReferentialKey';

/**
 * 
 * @export
 * @interface GetReferentialsByKeysCommand
 */
export interface GetReferentialsByKeysCommand {
    /**
     * 
     * @type {Array<ReferentialKey>}
     * @memberof GetReferentialsByKeysCommand
     */
    referentialKeys: Array<ReferentialKey>;
}

/**
 * Check if a given object implements the GetReferentialsByKeysCommand interface.
 */
export function instanceOfGetReferentialsByKeysCommand(value: object): value is GetReferentialsByKeysCommand {
    if (!('referentialKeys' in value) || value['referentialKeys'] === undefined) return false;
    return true;
}

export function GetReferentialsByKeysCommandFromJSON(json: any): GetReferentialsByKeysCommand {
    return GetReferentialsByKeysCommandFromJSONTyped(json, false);
}

export function GetReferentialsByKeysCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferentialsByKeysCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'referentialKeys': ((json['referentialKeys'] as Array<any>).map(ReferentialKeyFromJSON)),
    };
}

export function GetReferentialsByKeysCommandToJSON(json: any): GetReferentialsByKeysCommand {
    return GetReferentialsByKeysCommandToJSONTyped(json, false);
}

export function GetReferentialsByKeysCommandToJSONTyped(value?: GetReferentialsByKeysCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referentialKeys': ((value['referentialKeys'] as Array<any>).map(ReferentialKeyToJSON)),
    };
}

